import dAPI from './dapi';

const Categories = {
    all: ( query, options ) => {
        return dAPI.get( '/categories', query, options );
    },
    one: ( id, query ) => {
        return dAPI.get( '/categories/' + id, query );
    },
};

export default Categories;
